import { defineMessages } from 'react-intl';

/** Copy unique to the trial-end dual-seat pricing layout. */
export const trialEndPricingPlanCardsMessages = defineMessages({
  title: {
    defaultMessage: 'Choose the plan right for you',
    id: 'r/mbtzw9PZ',
    description: 'Heading of the pricing plans modal for the trial-end dual-card layout',
  },
  cancelAnytime: {
    defaultMessage: 'Cancel anytime.',
    id: 'azYBhuI+cv',
    description:
      'Subtitle under the pricing plans modal heading for the trial-end layout',
  },
  maxSeatWithOriginalPrice: {
    defaultMessage:
      '<strong>Max seat:</strong> <original>{originalPrice}</original> {price} user/month*',
    id: '5tvi6dVaOQ',
    description:
      'Max seat price line on a trial-end Clinician card when yearly billing lowers the price. {originalPrice} is struck through; the asterisk points at the sales tax footnote.',
  },
});
